export { default } from './CopyId';
